/*
 * @Author: Fone`峰
 * @Date: 2021-02-07 16:01:33
 * @LastEditors: Fone`峰
 * @LastEditTime: 2021-06-21 16:41:50
 * @Description: file content
 * @Email: qinrifeng@163.com
 * @Github: https://github.com/FoneQinrf
 */
/* eslint-disable */
export default {
    2001000024: '验证码过期或未发送',
    2001000025: '验证码错误',
}